import React, { useState } from "react";
import { MagnifyingGlassIcon } from "@phosphor-icons/react";
import { Route, Routes } from 'react-router-dom';
import { Link } from "react-router-dom";
import { motion } from 'framer-motion';

import Accordion from '../../components/Accordion/Accordion';
import Badge from '../../components/Badge/Badge';
import Button from '../../components/Button/Button';
import Checkbox from '../../components/Checkbox/Checkbox';
import Chip from '../../components/Chip/Chip';
// import Home from '../Home/Home';
import Input from '../../components/Input/Input';
import Radio from '../../components/Radio/Radio';
import Select from '../../components/Select/Select';
import Sidebar from '../../components/Sidebar/Sidebar';
import SoleCard from '../../components/SoleCard/SoleCard';
import Switch from '../../components/Switch/Switch';
import Tab from '../../components/Tab/Tab';
import Background from '../../components/Background/Background';
import Grid from '../../components/Grid/Grid';
import Position from '../../components/Position/Position'
import Width from '../../components/Width/Width';
import Space from '../../components/space/space';
import Text from '../../components/Text/Text';
import Toast from '../../components/Toast/Toast.js';
import Spa from '../../components/Spa/Spa';
import Modal from '../../components/Modal/Modal';
import Drawer from '../../components/Drawer/Drawer.js';
import Table from '../../components/Table/Table.js'

import './Main.css';
import DotArray from '../../components/DotArray/DotArray.js';
import Animation from '../../components/Animation/Animation.js';
import Transition from '../../components/Transition/Transition.js';
import Gap from '../../components/Gap/Gap.js';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb.js';
import Carousel from '../../components/Carousel/Carousel.js';
import Pagination from '../../components/Pagination/pagination.js';
import ProgressBar from '../../components/ProgressBar/progress.js';
import Spinner from '../../components/Spinners/spinner.js';
import Image from '../../components/Image/image.js';
import Shadow from '../../components/Shadows/Shadow.js';
import Popover from '../../components/Popovers/Popovers.js';
import Display from '../../components/Display/Display.js';
import TextArea from '../../components/TextArea/textarea.js';


const Main = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [isSearchVisible, setIsSearchVisible] = useState(false);

  const allData = [
    { id: 1, name: "Accordion", to: "/accordion" },
    { id: 2, name: "Button", to: "/button" },
    { id: 3, name: "Badge", to: "/badge" },
    { id: 4, name: "Card", to: "/solecard" },
    { id: 5, name: "Checkbox", to: "/checkbox" },
    { id: 6, name: "Chip", to: "/chip" },
    { id: 7, name: "Input", to: "/input" },
    { id: 8, name: "Radio", to: "/radio" },
    { id: 9, name: "Select", to: "/select" },
    { id: 10, name: "Switch", to: "/switch" },
    { id: 11, name: "Tab", to: "/tab" },
    { id: 12, name: "Colors", to: "/colors" },
    { id: 13, name: "Grid", to: "/grid" },
    { id: 14, name: "Position", to: "/position" },
    { id: 15, name: "Size", to: "/size" },
    { id: 16, name: "Space", to: "/space" },
    { id: 17, name: "Text", to: "/text" },
    { id: 18, name: "Modal", to: "/modals" },
    { id: 19, name: "Drawer", to: "/drawer" },
    { id: 20, name: "Toast", to: "/toast" },
    { id: 21, name: "DotParticle", to: "/dotparticle" },
    { id: 22, name: "Transition", to: "/transition" },
    { id: 23, name: "Carousel", to: "/carousel" },
    { id: 24, name: "Pagination", to: "/Pagination" },
    { id: 25, name: "Progress", to: "/progress" },
    { id: 26, name: "Spinner", to: "/spinner" },
    { id: 27, name: "Image", to: "/image" },
    { id: 28, name: "Shadow", to: "/shadow" },
    { id: 29, name: "popovers", to: "/popovers" },
    { id: 30, name: "Display", to: "/display" },
    { id: 31, name: "Textarea", to: "/textArea" },
    { id: 32, name: "Animation", to: "/animation" },
    { id: 33, name: "Gap", to: "/gap" },
    { id: 34, name: "Breadcrumb", to: "/breadcrumb" },
    { id: 35, name: "Table", to: "/table" },
  ];

  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    const filteredResults = allData.filter((item) =>
      item.name.toLowerCase().includes(query.toLowerCase())
    );
    setSearchResults(filteredResults);

    if (query === "") {
      setSearchResults([]);
    }
  };

  const handleClear = () => {
    setSearchQuery("");
    setSearchResults([]);
    setIsSearchVisible(false);
    closeDrawer();
  };


  const searchComp = () => {
    var drawerseek = document.getElementsByClassName('search-drawer')[0];
    drawerseek.classList.add('seek');
    document.body.classList.add('freeze');
  }
  const closeDrawer = () => {
    var drawerseek = document.querySelector('.search-drawer');
    var drawerChild = drawerseek.children[0];
    drawerChild.classList.add('drawer-hide');
    drawerseek.classList.add('waneout');
    setTimeout(() => {
      drawerseek.classList.remove('seek');
      drawerChild.classList.remove('drawer-hide');
      drawerseek.classList.remove('waneout');
      drawerseek.style.display = 'none'
      document.body.classList.remove('freeze');
    }, 290)
  }
  return (
    <motion.div
      initial={{ y: 10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -10, opacity: 0 }}
      transition={{ duration: 0.2 }}
    >
      <div className="Main">
        <div className='main-section'>
          <div className="carve-drawer search-drawer">
            <div className="carve-drawer-inner">
              <div className="carve-drawer-head">
                <div className="heading-medium">Search Component</div>
                <button className="icon icon-close" onClick={closeDrawer}>
                  &times;
                </button>
              </div>
              <div className="carve-drawer-body">
                <div
                  className={`search-group ${isSearchVisible ? "visible" : ""}`}
                  id="searchComponent"
                >
                  <svg
                    className="icon icon-search"
                    width="24"
                    height="24"
                    viewBox="0 0 256 256"
                  >
                    <path d="M232.49,215.51,185,168a92.12,92.12,0,1,0-17,17l47.53,47.54a12,12,0,0,0,17-17ZM44,112a68,68,0,1,1,68,68A68.07,68.07,0,0,1,44,112Z"></path>
                  </svg>
                  <input
                    type="text"
                    required
                    value={searchQuery}
                    onChange={handleSearchChange}
                    placeholder="Search..."
                  />
                  {searchResults.length > 0 && (
                    <ul className="search-results carve-list">
                      {searchResults.map((result) => (
                        <li>
                          <Link to={result.to} onClick={handleClear} key={result.id} aria-label={result.name}>
                            {result.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>
          </div>
          <motion.div
            initial={{ y: 10, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -10, opacity: 0 }}
            transition={{ duration: 0.2 }}
          >
            <button className="component_search" onClick={searchComp} aria-label="Search">
              <MagnifyingGlassIcon size={32} weight="regular" className="icon" />
            </button>

          </motion.div>
          <Routes>
            {/* <Route path='/home' element={<Home />} /> */}
            <Route path='accordion' element={<Accordion />} />
            <Route path='badge' element={<Badge />} />
            <Route path='button' element={<Button />} />
            <Route path='checkbox' element={<Checkbox />} />
            <Route path='chip' element={<Chip />} />
            <Route path='input' element={<Input />} />
            <Route path='radio' element={<Radio />} />
            <Route path='select' element={<Select />} />
            <Route path='solecard' element={<SoleCard />} />
            <Route path='switch' element={<Switch />} />
            <Route path='tab' element={<Tab />} />
            <Route path='colors' element={<Background />} />
            <Route path='grid' element={<Grid />} />
            <Route path='position' element={<Position />} />
            <Route path='size' element={<Width />} />
            <Route path='space' element={<Space />} />
            <Route path='text' element={<Text />} />
            <Route path='toast' element={<Toast />} />
            <Route path='spa' element={<Spa />} />
            <Route path='modals' element={<Modal />} />
            <Route path='drawer' element={<Drawer />} />
            <Route path='tables' element={<Table />} />
            <Route path='dotparticle' element={<DotArray />} />
            <Route path='animation' element={<Animation />} />
            <Route path='transition' element={<Transition />} />
            <Route path='gap' element={<Gap />} />
            <Route path='breadcrumb' element={<Breadcrumb />} />
            <Route path='carousel' element={<Carousel />} />
            <Route path='pagination' element={<Pagination />} />
            <Route path='progress' element={<ProgressBar progress={60} />} />
            <Route path='spinner' element={<Spinner />} />
            <Route path='image' element={<Image />} />
            <Route path='shadow' element={<Shadow />} />
            <Route path='popovers' element={<Popover />} />
            <Route path='display' element={<Display />} />
            <Route path='textArea' element={<TextArea />} />
          </Routes>
        </div>
        <Sidebar />
      </div>
    </motion.div>
  );
}



export default Main;
